import { render } from "./MypageNavbar.vue?vue&type=template&id=4b8d36c2"
import script from "./MypageNavbar.vue?vue&type=script&lang=js"
export * from "./MypageNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__